export enum UserRoles {
  MSP = 'MSP',
  VENDORTEAM = 'VendorTeam',
  TL = 'TL',
  HM = 'HM',
  CONTRACTOR = 'Contractor',
  VP = 'VP',
  INTERVIEWER = 'Interviewer',
  VENDOR = 'Vendor',
  FA = 'FA',
  PROCUREMENT = 'Procurement',
  SVP = 'SVP',
}

export const procurementPersonas = [UserRoles.PROCUREMENT, UserRoles.FA];

export const vendorPersonas = [UserRoles.VENDOR, UserRoles.VENDORTEAM];
export const miscPersonas = [UserRoles.CONTRACTOR, UserRoles.INTERVIEWER];

export const clientPersonas = [UserRoles.TL, UserRoles.HM, UserRoles.VP, UserRoles.SVP];

export const clientPersonasAndMSPProcurement = [
  UserRoles.TL,
  UserRoles.HM,
  UserRoles.VP,
  UserRoles.SVP,
  UserRoles.MSP,
  ...procurementPersonas,
];

export const clientExceptHMPersonas = [
  UserRoles.TL,
  UserRoles.VP,
  UserRoles.SVP,
  UserRoles.MSP,
  ...procurementPersonas,
];

export const clientExceptSVPPersonas = [
  UserRoles.TL,
  UserRoles.HM,
  UserRoles.VP,
  UserRoles.MSP,
  ...procurementPersonas,
];

export const clientExceptVPPersonas = [
  UserRoles.TL,
  UserRoles.HM,
  UserRoles.SVP,
  UserRoles.MSP,
  ...procurementPersonas,
];
